module.exports = __webpack_public_path__ + "static/img/cover.6fbd486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_3/cover.jpg
// module id = tBYw
// module chunks = 0